import { useEffect } from "react";

const FlodeskForm = ({ id }) => {
  useEffect(() => {
    const scriptModule = document.createElement("script");
    const scriptNoModule = document.createElement("script");
    const scriptBaseURL = "https://assets.flodesk.com/universal";
    const versionSuffix = `?v=${
      Math.floor(new Date().getTime() / (120 * 1000)) * 60
    }`;
    scriptModule.type = "module";
    scriptModule.src = `${scriptBaseURL}.mjs${versionSuffix}`;
    scriptModule.async = true;
    scriptNoModule.noModule = true;
    scriptNoModule.src = `${scriptBaseURL}.js${versionSuffix}`;
    scriptNoModule.async = true;
    document.body.appendChild(scriptModule);
    document.body.appendChild(scriptNoModule);
    window.fd =
      window.fd ||
      function () {
        (window.fd.q = window.fd.q || []).push(arguments);
      };

    window.fd("form", {
      formId: id,
      containerEl: `#fd-form-${id}`,
    });

    return () => {
      document.body.removeChild(scriptModule);
      document.body.removeChild(scriptNoModule);
    };
  }, []);
  return <div id={`fd-form-${id}`}></div>;
};

export default FlodeskForm;
